module.exports = __webpack_public_path__ + "img/introduce2.b1540350.png";